import merge from 'lodash/merge';
import type { CSSFn, ItemState } from '@atlaskit/menu';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import {
	castRealCSSFnToWronglyTypedCSSFn,
	type LegacyEmotionCssObject,
} from '../../../../../types.tsx';

export const cssFn: CSSFn = castRealCSSFnToWronglyTypedCSSFn<ItemState>(
	(currentStyles: LegacyEmotionCssObject): LegacyEmotionCssObject => {
		const newStyle = {
			'[data-edit-icon]': {
				display: 'none',
			},
			'&:hover [data-item-elem-after]': {
				'& > :not([data-edit-icon])': {
					display: 'none',
				},
				'& [data-edit-icon]': {
					display: 'flex',
				},
			},

			height: `${gridSize * 5.5}px`,
		};
		return merge(currentStyles, newStyle);
	},
);
